import type { paths } from './codegen/admin.types'
import { HOST } from '@/globals/typescript/utils/host'
import { i18n } from '@/locales'

import { getCurrentUserBearer } from './getCurrentUserBearer'
import { createLabApiClient } from '@team-milva/lab-utils'

export const adminApi = createLabApiClient<paths>({
  baseUrl: () => `${HOST.functions}/admin/v1`,
  defaultHeaders: () => {
    return {
      'Accept-Language': i18n.global.locale.value,
    }
  },
  getBearerToken: getCurrentUserBearer,
})

